import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import { useKonaseemaGuide } from "@/hooks/usePublicGuide";

export default function KonaseemaActivities() {
  const { activities: konaseemaActivities } = useKonaseemaGuide();
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-3xl mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-5">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
            <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
              Things To Do
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-950 font-semibold">
            Explore Konaseema Differently
          </h2>
          <p className="mt-5 text-base md:text-lg text-foreground-700 leading-relaxed">
            Beyond the farms, the delta is full of slow, beautiful experiences on land and water.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {konaseemaActivities.map((activity, index) => (
            <Reveal key={activity.title} delay={(index % 3) * 90}>
              <article className="h-full bg-background-100 rounded-lg border border-background-200 p-7 hover:border-primary-300 transition-colors">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                  <i className={`${activity.icon} text-2xl`}></i>
                </span>
                <h3 className="font-heading text-xl text-foreground-950 font-semibold mt-5">
                  {activity.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mt-3">{activity.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}